import { faPlus } from "@fortawesome/free-solid-svg-icons";
import useLeagueContext from "../../utils/useLeagueContext";
import { isDirectMessagePath } from "../../utils/leaguePath";
// Outlined 5-pointed star for the Watchlist tab (same FontAwesome family as the
// "+" tab). Colour is driven by the render below so it matches the sibling
// icons: grey #8A8B8F when inactive, green #35B23C when active.
import { faStar as faStarOutline } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./style.css";
import { useEffect } from "react";
import bag_grey from "../../images/new_bag.png";
import buy from "../../images/buy.png";
import bag from "../../images/colorbag.png";
import home_g from "../../images/home_g.png";
import home_q_grey from "../../images/home_q_grey.png";
import sell1 from "../../images/newsell.png";
import Chart from "../../images/chartgrey.png";
import ChartGreen from "../../images/chart_grey.png";

// Screens that live under /contest but are not a league: the create flow, the
// invite gate, the payoff, and the list pages.
const CONTEST_NON_LEAGUE = [
  "my-games",
  "add-league",
  "cash-leagues",
  "public-leagues",
  "create-public-league",
  "create-private-league",
  "private-league-created",
  "public-league-created",
  "private-league-preview",
  "private-league-joined",
  "join",
];

function Index() {
    // The bottom bar switches to the league environment only AFTER joining — a
    // visitor evaluating a competition is still driving their main account, so it
    // must keep the main menu. Membership, not the URL, is the trigger.
    const leagueCtx = useLeagueContext();

    const location = useLocation();

    const validPaths = ["feeds", "buysell", "charts", "portfolio", "leaderboard","create-feed","profile","chatHistory","trade","watchlist"];

    // Extract the first segment (slug) and the second segment of the path
    const pathSegments = location.pathname.split("/");

    // A league is addressed two ways, and the bottom bar has to recognise both or
    // it silently falls back to the GLOBAL menu while the user is inside a league
    // — which is how "+" ends up posting to the main feed instead of the league.
    //
    //   /<slug>/feeds, /<slug>/trade …   the per-league routes
    //   /contest/<slug>[/portfolio]      the revamped league Home and Portfolio
    const isContestLeague =
      pathSegments[1] === "contest" &&
      !!pathSegments[2] &&
      // /contest/<slug> and /contest/<slug>/portfolio are leagues; the flow
      // screens that live under /contest (create-…, join/…) are not.
      !CONTEST_NON_LEAGUE.includes(pathSegments[2]) &&
      (!pathSegments[3] || pathSegments[3] === "portfolio");

    // The first segment is the slug (e.g., "new")
    const slug = isContestLeague ? pathSegments[2] : pathSegments[1];

    // The second segment is the valid path (e.g., "buysell")
    const pathSegment = pathSegments[2];

    // Check if the second segment matches any of the valid paths
    const inJoinedLeague = leagueCtx.isMember;
    const isValidPath =
      inJoinedLeague && (isContestLeague || validPaths.includes(pathSegment));

    // Alert the slug and whether the path is valid



  // const menus = useMemo(
  //   () => [
  //     {
  //       label: "Feed",
  //       icon: home_q_grey,
  //       activeIcons: home_g,
  //       link: "/feed",
  //       dis: "translate-x-0",
  //     },
  //     {
  //       label: "Search",
  //       icon: bag_grey,
  //       activeIcons: bag,
  //       link: "/portfolio",
  //       dis: "translate-x-16",
  //     },
  //     {
  //       label: "Add",
  //       icon: faPlus,
  //       link: "/create-post",
  //       dis: "translate-x-32",
  //     },
  //     {
  //       label: "Buy Sell",
  //       icon: buy,
  //       activeIcons: sell1,
  //       link: "/buysell",
  //       dis: "translate-x-48",
  //     },
  //     {
  //       label: "Chart",
  //       icon: Chart,
  //       activeIcons: ChartGreen,
  //       link: "/charts",
  //       dis: "translate-x-64",
  //     },
  //   ],
  //   []
  // );


  const menus = useMemo(
  () => {
    if (isValidPath) {
      // Define menus for valid paths
      return [
{
        label: "Feed",
        icon: home_q_grey,
        activeIcons: home_g,
        link: `/contest/${slug}`,
        dis: "translate-x-0",
      },
      {
        label: "Search",
        icon: bag_grey,
        activeIcons: bag,
        link: `/contest/${slug}/portfolio`,
        dis: "translate-x-16",
      },
      {
        label: "Add",
        icon: faPlus,
        link: `/${slug}/create-feed`,
        dis: "translate-x-32",
      },
      {
        label: "Watchlist",
        // The league's own Watchlist screen (see LeagueWatchlist). This used to
        // point at a route that did not exist, which rendered a blank page, and
        // then at the app's /search, which walked the member out of the league —
        // client Rev 4: "it is currently pointing to the main QUSHi site instead
        // of staying in the league."
        icon: faStarOutline,
        activeIcons: faStarOutline,
        link: `/${slug}/watchlist`,
        dis: "translate-x-48",
        isIcon: true,
      },
      {
        label: "Chart",
        icon: Chart,
        activeIcons: ChartGreen,
        link: `/${slug}/trade`,
        dis: "translate-x-64",
      },
      ];
    } else {
      // Define menus for invalid paths or default paths
      return [
    {
        label: "Feed",
        icon: home_q_grey,
        activeIcons: home_g,
        link: "/feed",
        dis: "translate-x-0",
      },
      {
        label: "Search",
        icon: bag_grey,
        activeIcons: bag,
        link: "/portfolio",
        dis: "translate-x-16",
      },
      {
        label: "Add",
        icon: faPlus,
        link: "/create-post",
        dis: "translate-x-32",
      },
      {
        label: "Watchlist",
        icon: faStarOutline,
        activeIcons: faStarOutline,
        link: "/search",
        dis: "translate-x-48",
        isIcon: true,
      },
      {
        label: "Chart",
        icon: Chart,
        activeIcons: ChartGreen,
        link: "/charts",
        dis: "translate-x-64",
      },
      ];
    }
  },
  [isValidPath, slug] // Re-run when the league (or membership) changes
);

  const { pathname } = useLocation();

  const [active, setActive] = useState(
    menus.findIndex((x) => x.link === pathname)
  );

  useEffect(() => {
    setActive(menus.findIndex((x) => x.link === pathname));
  }, [pathname, menus]);

  // Chats screens own the bottom of the viewport: the thread screen pins its
  // composer above the safe area, so the bottom nav would sit on top of it.
  // isDirectMessagePath covers BOTH addresses a conversation has — the main app's
  // /chatHistory/:id[/:gid] and a league's /<slug>/chatHistory/:id. The league one
  // used to fall through to the menu, which is why the league bar sat over the
  // league conversation's composer once it became a full-screen pane like the
  // main app's.
  if (
    isDirectMessagePath(pathname) ||
    pathname === "/chat" ||
    pathname === "/notifications"
  ) {
    return null;
  }

  return (
    <>
      <div
        className="md:hidden flex justify-center fixed bottom-0 w-full bg-white left-0 z-20 h-16 bottom-navbar-container"
        onContextMenu={(e) => e.preventDefault()}
      >
        {" "}
        <div className="gap-4 relative grid grid-cols-5 w-full px-2">
          {menus[active] && (
            <span
              className={`h-16 w-16 absolute -top-5 rounded-full duration-500 ${menus[active]?.dis}`}
            ></span>
          )}
          {menus.map((menu, index) => (
            <NavLink
              key={index}
              to={menu.link}
              onClick={() => setActive(index)}
              onContextMenu={(e) => e.preventDefault()}
              className="buttonNavbarBottom"
            >
              <span
                className={
                  index === 2
                    ? `z-20 duration-500 ${"text-white"}`
                    : `text-xl z-20 ${index === active && " text-white"}`
                }
              >
                {menu.isIcon ? (
                  <FontAwesomeIcon
                    className={`w-9 h-9 ${index === active ? "text-[#35B23C]" : "text-[#8A8B8F]"}`}
                    icon={index === active ? menu.activeIcons : menu.icon}
                  />
                ) : index === active && index !== 2 ? (
                  <img className={index == 4 ? "text-gray h-[45px]" :"text-gray   h-8"} src={menu?.activeIcons} />
                ) :  index !== active && index !== 2 ? (
                  <img className={index == 4 ? "text-gray h-[45px]" : "text-gray   h-8"} src={menu?.icon} />
                ) : (
                  <FontAwesomeIcon
                    className={`${index === 2 && "bg-primaryColor w-8 h-8 rounded-full p-1"
                      }`}
                    icon={menu.icon}
                  />
                )}
              </span>
              {/* <span
              className={`text-xs font-semibold ${
                active === index
                  ? " text-green-500 translate-y-2 duration-500 opacity-100"
                  : "text-gray opacity-100  duration-500 translate-y-2"
              }`}
            >
              {index === 2 ? "" : menu.label}
            </span> */}
            </NavLink>
          ))}
        </div>
      </div>
    </>
  );
}

export default Index;
